import { Animated, Image, SafeAreaView, Text, View } from "react-native"
import React, { useEffect, useState } from "react"

import { CodeField, Cursor, useBlurOnFulfill, useClearByFocusCell } from "react-native-confirmation-code-field"

import styles from "./styles"

const { Value, Text: AnimatedText } = Animated

const CELL_COUNT = 6

const AnimatedConfirmationCodeInput = (prop) => {
    const [value, setValue] = useState("")
    const ref = useBlurOnFulfill({ value, cellCount: CELL_COUNT })
    const [props, getCellOnLayoutHandler] = useClearByFocusCell({
        value,
        setValue
    })

    useEffect(() => {
        prop.setValue && prop.setValue(value)
    }, [value])

    return (
        <CodeField
            ref={ref}
            {...props}
            value={value}
            onChangeText={setValue}
            cellCount={CELL_COUNT}
            rootStyle={styles.codeFiledRoot}
            keyboardType="number-pad"
            textContentType="oneTimeCode"
            renderCell={({ index, symbol, isFocused }) => (
                <View
                    onLayout={getCellOnLayoutHandler(index)}
                    key={index}
                    style={[styles.cellRoot, isFocused && styles.focusCell]}
                >
                    <Text style={styles.cellText}>{symbol || (isFocused ? <Cursor /> : null)}</Text>
                </View>
            )}
        />
    )
}

export default AnimatedConfirmationCodeInput
